import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './layout/Sidebar';
import { SidebarProvider, useSidebar } from '../context/SidebarContext';
import AdminHeader from './layout/AdminHeader';

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
      <div className='min-h-screen xl:flex'>
        <div>
          <Sidebar />
        </div>
        <div className={`flex-1 transition-all duration-300 ease-in-out ${ isExpanded || isHovered ? 'lg:ml-[290px]' : 'lg:ml-[90px]' } ${isMobileOpen ? 'ml-0' : ''}`}>
          <AdminHeader />
          <div className='p-4 mx-auto md:p-6'>
            <Outlet />
          </div>
        </div>
      </div>
  );
};

const ProtectedLayout: React.FC = () => {

  return (
      <SidebarProvider>
        <LayoutContent />
      </SidebarProvider>
  );
};

export default ProtectedLayout;
